import { useT } from "../lib/i18n";

export default function LanguageToggle({ className = "" }) {
    const { lang, setLang } = useT();
    return (
        <div className={`inline-flex items-center gap-1 text-[11px] tracking-[0.28em] uppercase ${className}`} data-testid="lang-toggle">
            <button
                onClick={() => setLang("en")}
                className={`px-2 py-1 transition-colors ${lang === "en" ? "text-gold" : "text-ink-secondary hover:text-ink-primary"}`}
                data-testid="lang-en"
            >EN</button>
            <span className="text-emerald-line">·</span>
            <button
                onClick={() => setLang("sv")}
                className={`px-2 py-1 transition-colors ${lang === "sv" ? "text-gold" : "text-ink-secondary hover:text-ink-primary"}`}
                data-testid="lang-sv"
            >SV</button>
        </div>
    );
}
